<template>
    <div class="topCard">
      <div>
        <img :src="post?.album?.cover_big"> <!-- Song -->
        <img :src="post?.cover_big"> <!-- Album -->
        <img :src="post?.picture_big"> <!-- Artist -->
      </div>
      <div class="description">
        <h2>{{post?.["title"]}}</h2> <!-- Song or Album-->
        <p>{{post?.["artist"]?.["name"]}}</p> <!-- Song -->
        <h2>{{post?.["name"]}}</h2> <!-- Artist -->
        <div class="buttonCont">
          <button class="playButton" @click="method(post)">Reproducir</button>
          <button class="dots icon"></button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name:'TopCard',
    props:{
        post: Object,
        method: Function,
    },
}
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css');

.topCard{
  width: 100%;
  height: 250px;
  margin: auto;
  background-color: #A70000B2;
  display: flex;
  color: white;
}
.description{
  text-align: start;
  margin-left: 30px;
  margin-top: 15px;
}
.buttonCont{
  margin-top: 90px;
  display: flex;
  gap: 20px;
}
.playButton{
  color: white;
  background-color: var(--mainred);
  height: 30px;
  width: 100px;
  border: 0px;
  border-radius: 15px;
  cursor: pointer;
}

.playButton:active{
  background-color: #e86060a5;
}
.dots{
  color: white;
  background-color: transparent;
  border: 0;
  font-size: 22px;
}
@media screen
 and (max-width:580px){
  .topCard{
    flex-direction: column;
    height: fit-content;
    width: fit-content;
    padding: 15px;
  }
  .description{
    text-align: center;
    margin: 0;
  }
  .buttonCont{
    margin: auto;
    justify-content: center;
    margin-bottom: 10px;
  }
}
</style>